export default __webpack_public_path__ + "static/media/17.b6d0f094.jpg";